import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

const ApiOrigins = [environment.serverUrl];
const isApiUrl = (url: string): boolean => {
  try {
    const requestUrl = new URL(url, window.location.origin);
    return ApiOrigins.some((origin) => requestUrl.origin === origin);
  } catch {
    return false;
  }
};

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  // Only add credentials to API requests
  if (isApiUrl(req.url) && !req.withCredentials) {
    const updatedReq = req.clone({
      withCredentials: true,
    });
    return next(updatedReq);
  }
  return next(req);
};
